import { useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './BottomActionBar.module.scss'

const BottomActionBar = ({ children }) => {
  const containerRef = useRef(null)
  const spacerRef = useRef(null)
  const { scrollable } = useSelector(({ drawer }) => drawer)

  useEffect(() => {
    const setSpacer = () => {
      if (scrollable && containerRef.current && spacerRef.current) {
        const height = containerRef.current.clientHeight
        spacerRef.current.style.height = `${height}px`
      }
    }
    setSpacer()
  }, [scrollable])

  return (
    <>
      <div
        className={`${styles.actionBar} ${scrollable ? styles.fixed : ''}`}
        ref={containerRef}
      >
        {children}
      </div>
      {scrollable && <div className={styles.actionSpacer} ref={spacerRef} />}
    </>
  )
}

BottomActionBar.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BottomActionBar
